function setNewCookie() {
  localStorage.setItem('cookieDate', Date.now());
  $.cookie('cookieDate', true, {
    expires: 7,
    path: '/'
  });
  $('#m-cookie').removeClass('show')
}

$(window).on('load', () => {
  // check cookie accept
  let checkCookies = {
    func: {
      check() {
        if ($('#m-cookie').length > 0) {
          let cookieDate = localStorage.getItem('cookieDate');
          let cookieBtnAccept = $('[data-cookie-accept]');

          // if cookie acept missing - show notification
          if (!cookieDate || (+cookieDate + 31536000000) < Date.now()) {
            $('#m-cookie').addClass('show')
          }

          // cookie accept btn click
          cookieBtnAccept.click(() => {
            setNewCookie()
          })

          // document random click accept btn click
          $(document).click((event) => {
            let val = event.target
            if ($('#m-cookie').hasClass('show')) {
              if ((val.className == 'm-cookie') || (val.className == 'm-cookie__link') || (val.className == 'm-cookie__text')) {
                return;
              }
              setNewCookie();
            }
          })
        }
      }
    }
  }

  checkCookies.func.check();
})
